import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["items", "nodeRef", "className"];
import React from 'react';
export var ApplicationActionBar = function ApplicationActionBar(_ref) {
  var items = _ref.items,
    nodeRef = _ref.nodeRef,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    remainigProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("ul", _extends({}, remainigProps, {
    className: "ApplicationActionBar nav navbar-nav navbar-right ".concat(className),
    ref: nodeRef
  }), items && items.map(function (item, index) {
    return /*#__PURE__*/React.createElement("li", {
      key: index,
      role: "presentation",
      className: "navigationItem"
    }, item);
  }));
};